$('.burger-menu').click(function (){
    $(this).toggleClass('burger-menu_opened');
    $('.header').toggleClass('header_opened');
});